var exports = {
  "kL": "GroupedVoiceParticipant.module__container___NkpwaE",
  "AG": "GroupedVoiceParticipant.module__participantButton___NkpwaE",
  "IT": "GroupedVoiceParticipant.module__participantButtonSpeaking___NkpwaE",
  "O": "GroupedVoiceParticipant.module__participantButtonContextMenuActive___NkpwaE",
  "SX": "GroupedVoiceParticipant.module__avatarAndName___NkpwaE",
  "VW": "GroupedVoiceParticipant.module__nameContainer___NkpwaE",
  "F8": "GroupedVoiceParticipant.module__participantName___NkpwaE",
  "xr": "GroupedVoiceParticipant.module__participantNameSpeaking___NkpwaE",
  "S$": "GroupedVoiceParticipant.module__participantNameCurrent___NkpwaE",
  "u$": "GroupedVoiceParticipant.module__deviceCountButton___NkpwaE",
  "g0": "GroupedVoiceParticipant.module__iconsAndToggle___NkpwaE",
  "pP": "GroupedVoiceParticipant.module__devicesContainer___NkpwaE",
  "nt": "GroupedVoiceParticipant.module__flexShrinkZero___NkpwaE",
};

module.exports = exports;
